import React from 'react';

const  About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">About Us</h1>
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <p className="mb-4">
            At Your Company, we are dedicated to providing top-notch services to our clients. With years of experience and a team of experts, we strive to deliver innovative solutions that meet the unique needs of each customer.
          </p>
          <p className="mb-4">
            Our mission is to empower businesses with cutting-edge technology and unparalleled support. We believe in building long-lasting relationships with our clients, based on trust, transparency, and mutual success.
          </p>
          <p>
            Whether you're a small startup or a large enterprise, we have the skills and resources to help you achieve your goals. Join us on this exciting journey of growth and transformation!
          </p>
        </div>
        <div className="relative h-64 md:h-full">
          <img
            src="/placeholder.jpg"
            alt="About Us"
            className="rounded-lg object-cover w-full h-full"
          />
        </div>
      </div>
    </div>
  );
}

export default About;

